import dayjs from "dayjs";
import "dayjs/locale/es";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isToday from "dayjs/plugin/isToday";
import objectSupport from "dayjs/plugin/objectSupport";
import utc from "dayjs/plugin/utc";

import { parseZone } from "../parseZone";

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isToday);
dayjs.extend(objectSupport);
dayjs.extend(parseZone);
dayjs.extend(utc);

/**
 * Thin wrapper for Day.js
 * See https://day.js.org/ for more details.
 */

export { dayjs as swaDate };
